import { createApp,ref } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/style/main.css';
import message from "./utils/message";
import alert from "./utils/alert";
import * as turf from "@turf/turf";
import { Buffer } from 'buffer';
if (typeof window.Buffer === 'undefined') {
window.Buffer = Buffer;
}
const app = createApp(App);
// 将 AhMessage 注册为全局方法
app.config.globalProperties.$message = message;
// 将 turf 挂载为全局属性
app.config.globalProperties.$turf = turf;
// 初始化全局地图容器
app.config.globalProperties.$map = null;
app.config.globalProperties.$setGlobalMap = function (mapInstance) {
    app.config.globalProperties.$map = mapInstance;
};
app.config.globalProperties.$loadingFlag =ref(false);
app.config.globalProperties.$openvideoflag =ref(false)
app.config.globalProperties.$videoLeng =ref(0)
app.config.globalProperties.$machineInLine =ref(false)
app.config.globalProperties.$boatpoint =ref(null)

// 注册全局的 Alert 管理器
app.use(alert);
app.use(store).use(router).mount('#app')
